@use "variables" as *;

.logoImage {
  position: absolute;
  justify-self: center;
}

.closeButtonBox {
  position: absolute;
  top: auto;
  bottom: auto;
  left: $spacing-m;
  width: 40px;
  height: 40px;
  border-radius: 40px !important;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);
}

.closeButton {
  border-radius: 30px !important;
}

.preferencesButton {
  position: absolute;
  right: $spacing-s;
  height: auto !important;
}
